import { ticks } from './config';

/**
 * Sproutlings: the range's sparring pen (ADR-0035), little garden creatures that stand their ground and never fight
 * back.
 */
export const MINION = {
  maxHp: 40,
  /** px/s, walking back to their spot. */
  speed: 34,
  bodyRadius: 4,
  hurtRadius: 6,
  /** Allies closer than this push apart. */
  separation: 9,
} as const;

/**
 * Mobs never stack (ADR-0031): minions, jungle creeps and the dead whose hurt circles overlap by more than `overlap`
 * px are pushed apart every tick (`crowdSystem`), so a crowd always reads as separate bodies.
 */
export const CROWD = {
  overlap: 2,
  /** Relaxation passes per tick (a packed crowd settles over a few ticks). */
  passes: 2,
} as const;

/** A base: Zombie Nights' Greenhouse (its health is `NIGHTS.baseHp`). */
export const BASE = {
  bodyRadius: 20,
  hurtRadius: 22,
} as const;

/**
 * Round flow (ADR-0015). A room starts in a lobby; between rounds (Zombie Nights' runs) there is an intermission. Both
 * end when the host's countdown runs out: `readyCountdownTicks` once everyone is ready, otherwise the intermission's full
 * `intermissionTicks` (a lobby only starts by itself in co-op rooms: `lobbyFullTicks` once everyone it was made for is
 * in, else after `lobbyAutoStartTicks`, ADR-0045 amended).
 */
export const ROUND = {
  intermissionTicks: ticks(30),
  readyCountdownTicks: ticks(3),
  lobbyAutoStartTicks: ticks(20),
  /**
   * A lobby that starts by itself counts this down once every seat is taken by someone who is here (no READY step): the
   * splash's countdown (ADR-0106), as long as everyone ready.
   */
  lobbyFullTicks: ticks(3),
} as const;
